import PromotionSaleTable from './PromotionSaleTable'
import { withPromotionSaleTable } from './withPromotionSaleTable'

const ConnectedPromotionSaleTable = withPromotionSaleTable(PromotionSaleTable)

export { ConnectedPromotionSaleTable as PromotionSaleTable }
